export default __webpack_public_path__ + "static/media/nft-lp-paint-no-blur.d78ece15.png";